import { getAllBanks } from '@/api/transfer'

const actions = {
    FETCH_BANKS: ({ commit }) => {
        getAllBanks()
            .then((data) => {
                commit('COMMIT_BANKS', data.data.data)
            })
            .catch((err) => {
                console.dir(err)
            })
    },
}

export default actions
